export default __webpack_public_path__ + "static/media/Company Info Icon.e661dcd7.svg";